module.exports = __webpack_public_path__ + "media/images/new-ui-images/new-dashboard-6079d0a1b61456e820827be91d269989.svg";